"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MLDCReactLoadingIndicator = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
function MLDCReactLoadingIndicator({ id, className, darkBackground, }) {
    return (react_1.default.createElement("div", { id: id, role: "status", "aria-label": "loading", "aria-live": "polite", tabIndex: 0, className: (0, classnames_1.default)("mldc-loading-indicator", className, darkBackground && "dark-bg") },
        react_1.default.createElement("div", { className: "dot-typing" }),
        react_1.default.createElement("div", { className: "dot-typing" }),
        react_1.default.createElement("div", { className: "dot-typing" })));
}
exports.MLDCReactLoadingIndicator = MLDCReactLoadingIndicator;
